import React from 'react';
import { Checkbox, Radio, Switch, Typography } from 'antd';
import RagQueryRewriteAdvancedOptions from '../collections/RagQueryRewriteAdvancedOptions';
import { TRIGGER_LABELS } from '../../utils/botDisplay';

const { Text } = Typography;

const TRIGGER_OPTIONS = [
  { value: 'direct', label: TRIGGER_LABELS.direct },
  { value: 'question', label: TRIGGER_LABELS.question },
  { value: 'all', label: TRIGGER_LABELS.all },
];

export default function BotTriggerFields({
  triggers,
  onTriggersChange,
  questionDetection,
  onQuestionDetectionChange,
  skipRepliesToOthers,
  onSkipRepliesToOthersChange,
  questionLlmPicker,
  cloudProviders = [],
  navigate,
  disabled,
}) {
  const hasQuestion = triggers.includes('question');

  const handleTriggersChange = (checked) => {
    let next = checked;
    if (checked.includes('all')) {
      next = ['all'];
    } else if (!next.length) {
      next = ['direct'];
    }
    onTriggersChange(next);
  };

  return (
    <div className="bot-trigger-fields">
      <Checkbox.Group
        options={TRIGGER_OPTIONS}
        value={triggers}
        onChange={handleTriggersChange}
        disabled={disabled}
        style={{ display: 'flex', flexDirection: 'column', gap: 8 }}
      />

      {hasQuestion && (
        <div className="bot-trigger-question-block" style={{ marginTop: 16 }}>
          <Text type="secondary" className="rag-query-rewrite-setting-label">
            Question detection
          </Text>
          <Radio.Group
            value={questionDetection}
            onChange={(e) => onQuestionDetectionChange(e.target.value)}
            disabled={disabled}
            style={{ display: 'flex', flexDirection: 'column', gap: 8, marginTop: 8 }}
          >
            <Radio value="heuristic">Heuristic (message contains ?)</Radio>
            <Radio value="llm">LLM classifier (should we answer?)</Radio>
          </Radio.Group>

          {questionDetection === 'heuristic' && (
            <div style={{ marginTop: 12 }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                <Switch
                  checked={skipRepliesToOthers}
                  onChange={onSkipRepliesToOthersChange}
                  disabled={disabled}
                />
                <Text type="secondary">
                  Ignore replies to other people (recommended in groups)
                </Text>
              </div>
              <Text type="secondary" style={{ display: 'block', marginTop: 6, fontSize: 12 }}>
                When on, a message that replies to someone else (not the bot) will not trigger,
                even if it contains ?. Turn off to restore the old ?-only behavior.
              </Text>
            </div>
          )}

          {questionDetection === 'llm' && (
            <div style={{ marginTop: 12 }}>
              <RagQueryRewriteAdvancedOptions
                compact
                hideMaxMessages
                hideSaveButton
                sectionTitle="Classifier model"
                modelStepLabel="Model for trigger classifier"
                picker={questionLlmPicker}
                cloudProviders={cloudProviders}
                navigate={navigate}
                disabled={disabled}
              />
            </div>
          )}
        </div>
      )}
    </div>
  );
}
